
export class MSubscribeTransferStore {

}

const instance = new MSubscribeTransferStore();

export default instance;